import { request } from './http';

export async function getGoverningBodies() {
    return request('/governing-bodies');
  }

export async function getGoverningBody(id) {
    return request(`/governing-bodies/${id}`);
  }

export async function createGoverningBody(data) {
    return request('/governing-bodies', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateGoverningBody(id, data) {
    return request(`/governing-bodies/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function deleteGoverningBody(id) {
    return request(`/governing-bodies/${id}`, {
      method: 'DELETE',
    });
  }

export const governingBodiesApi = {
  getGoverningBodies,
  getGoverningBody,
  createGoverningBody,
  updateGoverningBody,
  deleteGoverningBody,
};

